module.exports = __webpack_public_path__ + "img/calendar-gradient-event.a7b47d89.svg";